<template>
  <!-- eslint-disable -->
  <b-sidebar
    id="add-new-speciality"
    :visible="isAdd"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-backdrop
    @change="(val) => $emit('update:is-add', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ isEdit ? 'Editar' : 'Agregar nuevo' }} autoparte</h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="[hide(), resetForm()]" />
      </div>

      <!-- BODY -->
      <validation-observer #default="{ invalid }" ref="refFormObserver">
        <!-- Form -->
        <b-form class="p-2" @submit.prevent="onSubmit(items)">
          <!-- Titulo -->
          <validation-provider #default="{ errors }" name="categories" rules="requeridoE">
            <b-form-group label="Categoría de autoparte" label-for="categories">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="categories"
                label="name"
                input-id="categories"
                :reduce="(categories) => categories.id"
                v-model="items.autopartCategoryId"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="{ errors }" name="marcaA" rules="requeridoE">
            <b-form-group label="Marca de autoparte" label-for="marcasA">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="marcasA"
                label="name"
                input-id="marcasA"
                :reduce="(marcasA) => marcasA.id"
                v-model="items.autopartBrandId"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
            <b-form-group label="Marca de vehiculo" label-for="marcasv">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="marcasV"
                label="name"
                input-id="marcasv"
                :reduce="(marcasV) => marcasV.id"
                v-model="items.carBrandId"
                @input="selectMarca(items.carBrandId)"
              />
            </b-form-group>
          <validation-provider #default="{ errors }" name="modelos" rules="requeridoE">
            <b-form-group label="Modelos" label-for="modelos">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="models"
                label="name"
                input-id="modelos"
                multiple
                :reduce="(model) => model.id"
                v-model="items.modelsIds"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="{ errors }" name="originalCode" rules="requeridoE">
            <b-form-group label="Codigo Original" label-for="codOri">
              <b-form-input
                id="codOri"
                autofocus
                trim
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Codigo Original"
                v-model="items.originalCode"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="{ errors }" name="codAlt" rules="requeridoE">
            <b-form-group label="Codigo Alterno" label-for="codAlt">
              <b-form-input
                id="codAlt"
                autofocus
                trim
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Codigo Alterno"
                v-model="items.alterCode"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="{ errors }" name="descripcion" rules="requeridoE">
            <b-form-group label="Descripción" label-for="descripcion">
              <b-form-input
                id="descripcion"
                autofocus
                trim
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Descripción"
                v-model="items.description"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="{ errors }" name="retailPrice" rules="requeridoE">
            <b-form-group label="Precio Tienda" label-for="precio_menor">
              <b-form-input
                id="precio_menor"
                autofocus
                trim
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Precio Tienda"
                type="number"
                step="0.01"
                v-model="items.retailPrice"
                @keypress="onlyNumbers($event)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="{ errors }" name="wholesalePrice" rules="requeridoE">
            <b-form-group label="Precio x Mayor" label-for="precio_mayor">
              <b-form-input
                id="precio_mayor"
                autofocus
                trim
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Precio x Mayor"
                step="0.01"
                v-model="items.wholesalePrice"
                type="number"
                @keypress="onlyNumbers($event)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="{ errors }" name="clientPrice" rules="requeridoE">
            <b-form-group label="Precio Cliente Final" label-for="precio_cliente_final">
              <b-form-input
                id="precio_cliente_final"
                autofocus
                trim
                :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Precio Cliente Final"
                step="0.01"
                v-model="items.clientPrice"
                type="number"
                @keypress="onlyNumbers($event)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="{ errors }" name="extendedDescription">
            <b-form-group label="Extra Descripcion" label-for="extra_descrip">
              <b-form-textarea
                :class="errors.length > 0 ? 'is-invalid' : null"
                id="extra_descrip"
                placeholder="Extra Descripcion"
                rows="3"
                autofocus
                trim
                v-model="items.extendedDescription"
                no-resize
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
          <!-- Form Actions -->
          <div class="d-flex mt-2 justify-content-end">
            <b-button
              :disabled="invalid"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              <b-spinner v-if="isDisabled" small />
              <span v-if="isDisabled" class="px-1">guardando...</span>
              <span v-else>{{isEdit ? 'Actualizar': 'Agregar'}}</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="[hide(), resetForm()]"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable*/
import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AutoPartsService from '@/services/AutoParts'
import VehicleService from '@/services/VehicleService'
import vSelect from 'vue-select'
Vue.use(BootstrapVue)
export default {
  directives: {
    Ripple
  },
  components: {
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    vSelect
  },
  props: {
    isAdd: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      required,
      isEdit: false,
      isDisabled: false,
      items: {
        originalCode: '',
        alterCode: '',
        description: '',
        extendedDescription: '',
        autopartCategoryId: null,
        autopartBrandId: null,
        carBrandId: null,
        retailPrice: null,
        wholesalePrice: null,
        clientPrice: null,
        modelsIds: [],
      },
      marcasA: [],
      categories: [],
      marcasV: [],
      extraFilters: [],
      filterModels: [],
      models: [],
      temp: {}
    }
  },
  mounted() {
    this.getExtraData()
  },
  methods: {
    onlyNumbers(e) {
      if ((e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode == 46) {
        return true
      } else {
        e.preventDefault()
      }
    },
    async selectMarca(marca){
      this.models = []
      console.log("MARCA: ", marca)
      this.items.modelsIds = [];
      this.filterModels = []
      this.$refs.refFormObserver.reset()
      if (marca){
        this.filterModels.push({ keyContains: 'brand.id', key: 'equals', value: parseInt(marca) });
      }
      const url = `?limit=100&page=1&order=desc&sort=id&filter=${JSON.stringify(this.filterModels)}`;
      console.log("URL MODELOS: ", url)
      const resp = await VehicleService.getModels(url, this.$store)
      console.log("RESP MODELS: ",resp)
      if (resp.data.rows.length != 0) {
        this.models = resp.data.rows
      }
    },
    async getExtraData() {
      const url = `?limit=100&page=1&order=asc&sort=id&filter=${JSON.stringify(this.extraFilters)}`;
      const respBrand = await AutoPartsService.getAutoPartsBrand(url,this.$store)
      console.log("RESP: ",respBrand)
      if (respBrand) {
        this.marcasA = respBrand.data.rows
      }
      const respCategory = await AutoPartsService.getAutoPartsCategory(url,this.$store)
      if (respCategory) {
        this.categories = respCategory.data.rows
      }
      const respVehicle = await VehicleService.getAutoPartsVehicle(url, this.$store)
      if (respVehicle) {
        this.marcasV = respVehicle.data.rows
      }
    },
    getData(items) {
      if (Object.entries(items).length !== 0) {
        this.temp = items;
        this.items = items;
        this.isEdit = true;
        if (this.items.carBrandId) {
          this.loadModels(this.items.carBrandId);
        }
      } else {
        this.isEdit = false;
        this.resetForm();
      }
      console.log('temp EN ADD', this.temp);
    },
    async loadModels(carBrandId) {
      this.models = [];
      if (carBrandId) {
        const url = `?filter=[{"keyContains":"brand.id","key":"equals","value":${carBrandId}}]`;
        const resp = await VehicleService.getModels(url, this.$store);
        this.models = resp.data.rows;
      }
    },
    resetForm() {
      this.$refs.refFormObserver.reset()
      this.isEdit = false
      this.items = {
        originalCode: '',
        alterCode: '',
        description: '',
        extendedDescription: '',
        autopartCategoryId: null,
        autopartBrandId: null,
        carBrandId: null,
        retailPrice: null,
        wholesalePrice: null,
        clientPrice: null,
        modelsIds: [],
      }
    },
    onSubmit(data) {
      let datos = { ...data }
      datos.retailPrice = parseFloat(data.retailPrice)
      datos.wholesalePrice = parseFloat(data.wholesalePrice)
      datos.clientPrice = parseFloat(data.clientPrice)
      const marcaSeleccionada = this.marcasA.find(marca => marca.id === datos.autopartBrandId)
      const nombreMarca = marcaSeleccionada ? marcaSeleccionada.name.trim().toUpperCase().replace(/\s+/g, '_') : ''

      datos.uniqueCode = `${nombreMarca}_${datos.originalCode.trim()}`
      
      console.log('DATOS NUEVOS: ', datos)
      this.$refs.refFormObserver.validate().then(async (success) => {
        if (success) {
          this.isDisabled = true
          let resp = ''
          if (this.isEdit == false) {
            resp = await AutoPartsService.saveAutoPart(datos, this.$store)
          } else {
            let datosUpdate = {
              uniqueCode: datos.uniqueCode,
              originalCode: datos.originalCode,
              alterCode: datos.alterCode,
              description: datos.description,
              extendedDescription: datos.extendedDescription,
              autopartCategoryId: datos.autopartCategoryId,
              autopartBrandId: datos.autopartBrandId,
              carBrandId: datos.carBrandId,
              retailPrice: datos.retailPrice,
              wholesalePrice: datos.wholesalePrice,
              clientPrice: datos.clientPrice,
              modelsIds: datos.modelsIds,
            }
            resp = await AutoPartsService.updateAutoPart(data.id, datosUpdate, this.$store)
          }
          if (resp) {
            this.$swal({
              title: 'Añadido',
              text: 'La autoparte ha sido ' + (this.isEdit == true ? 'actualizado.' : 'registrado.'),
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
            this.isDisabled = false
            console.log('this.$parent.$parent', this.$parent.$parent)
            this.$parent.$parent.$parent.getData()
            this.$emit('update:is-add', false)
            this.resetForm()
          } else {
            this.$swal({
              title: 'Error!',
              text: ' Hubo un error al ' + (this.isEdit == true ? 'actualizar' : 'registrar') + ' la autoparte',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
          }
          this.isDisabled = false
        } else {
          console.log('no validado')
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
